import { render, staticRenderFns } from "./SectionSvg.vue?vue&type=template&id=3e914890&scoped=true&"
import script from "./SectionSvg.vue?vue&type=script&lang=js&"
export * from "./SectionSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e914890",
  null
  
)

export default component.exports